export default {
    功能管理: 'Function management'
}
